/**
 * @generated SignedSource<<b225791bbc02485a648a3cb35603acdb>>
 * @relayHash 3bebc9b916816a4421a88a5541e30086
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsAutoConvertedRecentlyQuery$variables = {
  contentId: string;
};
export type useIsAutoConvertedRecentlyQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentProperties: {
        readonly draft: {
          readonly autoConvertedDate: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly fabricEditorSupported: boolean | null | undefined;
        } | null | undefined;
      };
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useIsAutoConvertedRecentlyQuery = {
  response: useIsAutoConvertedRecentlyQuery$data;
  variables: useIsAutoConvertedRecentlyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ],
            "storageKey": "properties(key:\"editor\")"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorSupported"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "ContentProperties",
            "kind": "LinkedField",
            "name": "contentProperties",
            "plural": false,
            "selections": [
              {
                "concreteType": "DraftContentProperties",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "autoConvertedDate"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsAutoConvertedRecentlyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsAutoConvertedRecentlyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3bebc9b916816a4421a88a5541e30086",
    "id": "c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8",
    "metadata": {},
    "name": "useIsAutoConvertedRecentlyQuery",
    "operationKind": "query",
    "text": "query useIsAutoConvertedRecentlyQuery($contentId:ID!){content(id:$contentId){nodes{id,properties(key:\"editor\"){nodes{value}},metadata{frontend{fabricEditorSupported}},contentProperties{draft{autoConvertedDate}}}}}"
  }
};
})();

(node as any).hash = "bd10bb6670b064c3529095e127e8cdf2";

export default node;
